export default {
  lang: "ko",
  关于: "에 대한",
  角色: "역할",
  NFT: "NFT",
  币安顺风车: "币安顺风车",
  发布行程: "여행 등록하기",
  获取最新资讯: "최신 소식을 받아보세요",
  立即加入社区: "지금 커뮤니티에 가입하세요",
  购买: "구매",
  "币安顺风车平台 是一个结合了区块链技术与绿色出行理念的创新项目。它通过顺风车、步行和公共交通等多种方式，让用户不仅享受便捷的出行，还可以赚取币安顺风车代币奖励，实现经济收益。凭借其多样化的奖励机制、NFT 系统和长期的代币分配模型，币安顺风车平台 为用户提供了一个独特的「边走边赚」的机会。展望未来，币安顺风车平台 有望成为区块链领域中出行类应用的先锋，吸引越来越多的用户加入并从中受益。在全球环境问题日益严重的背景下，币安顺风车平台 的绿色出行理念也符合可持续发展的趋势，既为用户带来便利，又为环境保护贡献力量。":
    "币安顺风车플랫폼는 블록체인 기술과 친환경 이동 개념을 결합한 혁신적인 프로젝트입니다. 카풀, 도보, 대중교통 등 다양한 방법을 통해 사용자에게 편리한 이동을 제공하고, 币安顺风车 토큰 보상을 통해 경제적 수익을 얻을 수 있습니다. 다양한 보상 메커니즘, NFT 시스템 및 장기적인 토큰 분배 모델을 통해 币安顺风车플랫폼는 사용자에게 독특한 '걷는 동안 벌기'의 기회를 제공합니다. 미래를 바라보면, 币安顺风车플랫폼는 블록체인 분야의 이동 애플리케이션의 선두주자가 될 것으로 기대되며, 점점 더 많은 사용자가 참여하고 혜택을 받을 것입니다. 전 세계 환경 문제가 심각해짐에 따라 币安顺风车플랫폼의 친환경 이동 개념은 지속 가능한 발전 추세와 일치하며, 사용자에게 편리함을 제공하는 동시에 환경 보호에도 기여하고 있습니다.",
  "日常行程赚取 币安顺风车": "일상 일정으로 币安顺风车 벌기",
  "在 币安顺风车平台 项目中，用户可以通过完成顺风车、步行或使用公共交通来赚取 币安顺风车 代币。行程的奖励基于“打卡点”机制，奖励取决于打卡点的数量和每个打卡点的奖励值。":
    "币安顺风车플랫폼 프로젝트에서 사용자는 카풀, 도보 또는 대중교통을 이용하여 币安顺风车 토큰을 벌 수 있습니다. 일정의 보상은 '체크인 포인트' 메커니즘에 기반하며, 보상은 체크인 포인트의 수와 각 체크인 포인트의 보상 값에 따라 결정됩니다.",
  单个行程的奖励规则: "단일 일정의 보상 규칙",
  "奖励计算公式：行程奖励 = 打卡点数量 × 单个打卡点奖励值":
    "보상 계산 공식: 일정 보상 = 체크인 포인트 수 × 단일 체크인 포인트 보상 값",
  "单个打卡点奖励值：公式：个人奖励基数 × (个人质押数量÷10,000)¹/⁴ 说明：个人奖励基数随全网总质押量动态变化调整，且全网每日奖励总额上限为 5,120 枚。":
    "단일 체크인 포인트 보상 값: 공식: 개인 보상 기준 × (개인 스테이킹 수량 ÷ 10,000)¹/⁴.\n 설명: 개인 보상 기준은 전체 네트워크의 총 스테이킹 양에 따라 동적으로 조정되며, 전체 네트워크의 일일 보상 한도는 5,120개입니다.",
  顺风车司机: "카풀 드라이버",
  "每日可获得额外 2 个行程次数":
    "매일 추가로 2개의 일정 횟수를 얻을 수 있습니다.",
  出行达人: "여행 전문가",
  "每日可获得 5 个额外行程次数":
    "매일 추가로 5개의 일정 횟수를 얻을 수 있습니다.",
  车队老板: "차량 팀장",
  "每日可获得 100 个额外行程次数，可以将行程次数赠送给好友":
    "매일 추가로 100개의 일정 횟수를 얻을 수 있으며, 친구에게 일정 횟수를 선물할 수 있습니다.",
  城市合伙人: "도시 파트너",
  "每日可获得 1000 个额外行程次数，可以将行程次数赠送给好友":
    "매일 추가로 1000개의 일정 횟수를 얻을 수 있으며, 친구에게 일정 횟수를 선물할 수 있습니다.",
  车主汽车NFT: "차주 자동차 NFT",
  新星之驾: "스타 드라이버",
  银翼之旅: "은빛 날개 여행",
  金辉之路: "금빛 길",
  耀世之行: "빛나는 여정",
  传奇之旅: "전설적인 여행",
  非车主服饰NFT: "비차주 의상 NFT",
  普通款: "일반 버전",
  晨曦之装: "새벽의 옷",
  霞光之服: "여명 의상",
  月华之衣: "달빛의 의상",
  日曜之袍: "햇살의 로브",
  免费: "무료",
  打点奖励基数: "보상 기준",
  "币安顺风车 Token 简介": "Binance Ride-sharing 토큰 소개",
  "概述 币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。 核心参数 • 代币标准：BEP-20（BSC） • 最大供应：1,000,000,000 • 启动即焚毁：700,000,000（链上可查） • 启动后剩余供应：300,000,000（其中 200,000,000 锁定用于行程挖矿奖励，非流通） 产出与奖励机制 • 行程奖励=打卡点数量 × 单个打卡点奖励值 • 单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4) • 个人奖励基数随全网总质押量动态调整 • 全网单日奖励总上限：5,120 枚 公平发射与官方参与 • 零预售、零预留、零私募；全程公开透明 • 官方通过 four.meme 公平购入 218,888,888 枚： – 200,000,000 枚锁入智能合约用于“行程挖矿” – 10,000,000 枚用于平台内积分兑换 – 8,888,888 枚用于社区活动与生态激励 • 绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查 团队长计划 • 全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB • 预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰 • 公平发射分配（核心 60,000,000 枚）： – 42,000,000 枚按投入比例分配 – 18,000,000 枚作为“团队长特殊贡献奖” • 前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权 团队长计划官方唯一地址： 0xbc74845Ea341F1203704b2CDcEDEE27060260605 代币用途与价值 • 出行激励：完成有效行程获得代币 • 权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等 • 生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "개요 币安顺风车는 블록체인 기술과 친환경 이동을 결합한 응용형 프로젝트로, 사용자는 카풀, 도보, 대중교통 등 일상적인 이동을 통해 토큰 보상을 획득하며 ‘이동하며 수익을 얻는(Move to Earn)’ 개념을 실현합니다. 본 프로젝트는 공정한 런칭과 완전한 온체인 투명성을 원칙으로 하며, 장기적 인센티브와 지속 가능한 생태계 성장을 강조합니다. 핵심 파라미터 • 토큰 표준: BEP-20 (BSC) • 최대 공급량: 1,000,000,000 • 런칭 시 소각: 700,000,000 (온체인 확인 가능) • 런칭 후 잔여 공급량: 300,000,000 (이 중 200,000,000은 이동 마이닝 보상용으로 잠금, 비유통 상태) 생산 및 보상 메커니즘 • 이동 보상 = 체크인 포인트 수 × 단일 포인트 보상값 • 단일 포인트 보상값 = 개인 보상 기준 × (개인 스테이킹 수량 ÷ 10,000)^(1/4) • 개인 보상 기준은 전체 네트워크의 총 스테이킹 양에 따라 동적으로 조정됨 • 전체 네트워크의 일일 보상 한도: 5,120개 공정한 런칭 및 공식 참여 • 사전판매 없음, 예약 없음, 프라이빗 세일 없음; 전 과정 완전 투명 • 공식 팀은 four.meme을 통해 218,888,888개를 공정하게 구매함: – 200,000,000개는 스마트 계약에 잠금되어 ‘이동 마이닝’에 사용 – 10,000,000개는 플랫폼 포인트 교환용 – 8,888,888개는 커뮤니티 활동 및 생태계 인센티브용 • 본딩 커브 메커니즘은 구매 시 자동으로 가격이 상승하며, 공식 팀과 커뮤니티는 동일한 가격으로 참여하고 온체인에서 검증 가능 팀장 프로그램 • 전 세계 한정 100명 팀장 모집: 1인당 0.7 BNB, 총 70 BNB • 약 7.6억 개 토큰 구매 가능, 이 중 7억 개는 즉시 소각되어 희소성 구조가 명확함 • 공정한 런칭 분배 (핵심 60,000,000개): – 42,000,000개는 기여 비율에 따라 분배 – 18,000,000개는 ‘팀장 특별 공헌 보상’으로 제공 • 상위 100명은 1개월간 ‘차량대 소유자’ 자격을 부여받으며, 플랫폼 내 이용 횟수 증가, 특권 제공, 전용 배지 및 이벤트 우선권을 누릴 수 있음 공식 팀장 프로그램 주소: 0xbc74845Ea341F1203704b2CDcEDEE27060260605 토큰의 활용 및 가치 • 이동 인센티브: 유효한 이동을 완료하면 토큰을 획득 • 권한 및 교환: 플랫폼 포인트 교환, 이벤트 보상, NFT 권한과 연계 가능 • 생태계 성장: 카풀 중심의 다양한 이동 시나리오를 통해 실제 이동을 장려하고 친환경 저탄소 행동을 촉진",
  "在STON.FI上购买": "STON.FI에서 구매하기",

  概述: "개요",
  "币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。":
    "Binance Ride-sharing은 블록체인과 친환경 이동을 결합한 애플리케이션 프로젝트입니다. 사용자는 카풀, 도보, 대중교통 등 일상적인 이동을 통해 토큰 보상을 받아 'Move-to-Earn'을 실현합니다. 공정한 출시와 전 과정 투명성을 고수하며 장기적인 인센티브와 지속 가능한 생태계 성장을 강조합니다.",
  核心参数: "핵심 파라미터",
  "代币标准：BEP-20（BSC）": "토큰 표준: BEP-20 (BSC)",
  "最大供应：1,000M": "최대 공급량: 1,000M",
  "启动即焚毁：432.46M（链上可查）":
    "출시 즉시 소각: 432.46M (온체인 확인 가능)",
  "启动后剩余供应：567M": "출시 후 잔여 공급량: 567M",
  "– 其中 200M 锁定用于行程挖矿奖励，非流通":
    "– 그중 200M은 여정 채굴 보상으로 잠금 설정됨 (비유통)",
  "– 其中 10M 锁定用于积分兑换等":
    "– 그중 10M은 포인트 교환 등으로 잠금 설정됨",
  产出与奖励机制: "산출 및 보상 메커니즘",
  "行程奖励=打卡点数量 × 单个打卡点奖励值":
    "여정 보상 = 체크포인트 수 × 개별 체크포인트 보상값",
  "单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4)":
    "개별 체크포인트 보상값 = 개인 보상 기준치 × (개인 스테이킹 수량 ÷ 10,000)^(1/4)",
  个人奖励基数随全网总质押量动态调整:
    "개인 보상 기준은 전체 네트워크의 총 스테이킹량에 따라 동적으로 조정됩니다.",
  "全网单日奖励总上限：5,120 枚": "전체 네트워크 일일 보상 상한: 5,120개",
  公平发射与官方参与: "공식 공정 발행 참여",
  "零预售、零预留、零私募；全程公开透明":
    "사전 판매 없음, 예약 물량 없음, 프라이빗 세일 없음; 전 과정 공개 및 투명",
  "官方通过 four.meme 公平购入 210M 枚：":
    "공식 팀이 four.meme을 통해 210M개를 공정하게 매입:",
  "– 200M 枚锁入智能合约用于“行程挖矿”":
    "– 200M개는 '여정 채굴'을 위해 스마트 컨트랙트에 잠금 설정",
  "– 10M 枚用于平台内积分兑换": "– 10M개는 플랫폼 내 포인트 교환에 사용",
  "– 8,888,888 枚用于社区活动与生态激励":
    "– 8,888,888개는 커뮤니티 활동 및 생태계 인센티브용",
  "绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查":
    "본딩 커브 메커니즘에 따라 구매 시 가격이 자동 상승하며, 공식 팀과 커뮤니티가 동일한 가격으로 진입 (온체인 확인 가능)",
  团队长计划: "팀 리더 프로그램",
  "全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB":
    "전 세계 한정 100명의 팀 리더 모집: 1인당 0.7 BNB, 총 70 BNB",
  "预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰":
    "약 7.6억 개 토큰 구매 예상, 이 중 7억 개는 즉시 소각 — 희소 구조 명확",
  "公平发射分配（核心 60,000,000 枚）：": "공정 발행 배분 (핵심 60,000,000개):",
  "– 42,000,000 枚按投入比例分配": "– 42,000,000개는 투자 비율에 따라 배분",
  "– 18,000,000 枚作为“团队长特殊贡献奖”":
    "– 18,000,000개는 ‘팀 리더 특별 공헌 보상’으로 지급",
  "前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权":
    "최초 100명은 1개월간 ‘플릿 오너(Fleet Owner)’ 자격 부여 (배당금 없음) - 플랫폼 내 이용 횟수 증가, 권한 제공, 전용 배지 및 이벤트 우선권 부여",
  "团队长计划官方唯一地址：": "팀 리더 프로그램 공식 유일 주소:",
  代币用途与价值: "토큰 활용 및 가치",
  "出行激励：完成有效行程获得代币":
    "이동 인센티브: 유효한 여정 완료 시 토큰 획득",
  "权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等":
    "권한 및 교환: 플랫폼 포인트 교환, 이벤트 인센티브, NFT 권한 연동 등에 사용",
  "生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "생태계 성장: 카풀 중심의 다양한 시나리오 응용을 통해 실제 이동과 친환경 저탄소 행동 장려",
};
